import React from 'react'
import MainSkeleton from './MainSkeleton'

const SkillSkeleton = () => {
  return (
    <div className='w-[100px]'>
        <MainSkeleton classes={'w-full h-[100px]'}/>
        <MainSkeleton classes={'w-full h-[30px]'}/>
    </div>
  )
}

export default SkillSkeleton